import { useCallback, useContext } from 'react';
import { consoleIfNotProd } from 'chatspot-core/loggers/consoleIfNotProd';
import { CopilotChannelContext } from '../CopilotChannelContext';
export function useSendOnCopilotChannel(topic) {
  const {
    channel
  } = useContext(CopilotChannelContext);
  return useCallback(data => {
    if (!channel) {
      consoleIfNotProd.error(`Channel not found.  Are you trying to send a message on the copilot channel outside of <CopilotProvider/>?`);
      return;
    }
    channel.postToTopic(topic, data);
  }, [channel, topic]);
}